import { createFileRoute } from '@tanstack/react-router';
import ActivityView from '../jobs/view/activity/activity-view';

export const Route = createFileRoute('/orders/$orderGuid_/jobs/$jobGuid/activity')({
  component: ActivityView,
});
